import { EndCoverageComponent } from './end-coverage.component';
import { sectionConfiguration } from '@app/helpers/models.helpers';
import { aPath } from '@app/helpers/function.helpers';
// import Vs from '@app/services/validators/validators.service';


const formValidation = (fb, recordData) => {  
  const hhMembers = aPath(['endMyCoverage'], recordData);
  const endCvgOrMoveOutSw = aPath(['endCvgOrMoveOutSw'], recordData);
  const moveSomeoneOutSwSaved = aPath(['moveSomeoneOutSw'], recordData);
  const isOnlyEndCoverageTileSelected = aPath(['onlyEndCvgTileSelected'], recordData);

  const helpers = fb.group({
    doNotEndCoverage: [''],
    termChoice: [null],
  });

  const data = fb.group({
    householdList: fb.array(hhMembers),
    selectedList: fb.control([], { nonNullable: true }),
    moveSomeoneOutSw: [moveSomeoneOutSwSaved || null],
    endCvgOrMoveOutSw: [endCvgOrMoveOutSw || null],
    isOnlyEndCoverageTileSelected: [isOnlyEndCoverageTileSelected || null],
  });
  return { data, helpers };
}

export default sectionConfiguration(EndCoverageComponent, formValidation, ['YESNO'], [], {}, {
  hasSummary: false,
  showComments: true,
  showSubmit: false,
});
